import * as React from 'react';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import './Blog.css';
import { ARTICLES } from './Articles/Articles';

interface IProps {
    steps?: number,
    currentArticle?: {path: string;}
}

interface IState {
    currentStep: number,
    windowSize: number
}

export class BlogSlider extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            currentStep: 0,
            windowSize: window.innerWidth
        }

        this.moveSlider = this.moveSlider.bind(this);
    }
    
    public componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }

    public componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    public render() {
        const { steps = ARTICLES.length, currentArticle } = this.props;
        const { currentStep, windowSize } = this.state;

        const [desktopBreakpoint, mobileBreakpoint, desktopWidth, mobileWidth] = [1280, 767, 428, 312];
        const maxStep = windowSize > desktopBreakpoint ? steps - 2 : steps;
        
        const slideWidth = windowSize > mobileBreakpoint ? desktopWidth: mobileWidth;
        const sliderWidth = slideWidth * steps;

        return (
            <div className="blog-slider-wrapper">
                <div className="blog-slider-container">
                    <div 
                        className="blog-slider"
                        style={{
                            width: `${(sliderWidth)}px`,
                            transform: `translate3d(${-(slideWidth * currentStep)}px, 0, 0)`
                        }}
                    >
                        {ARTICLES
                            .filter(item => {
                                return currentArticle ? item.path !== currentArticle.path : true;
                            })
                            .map(({id, path, title, sliderImg: img, tag, author}) => (
                                <Link 
                                    to={`/blog/${path}`} 
                                    className="blog-slider-item"
                                    key={id}
                                >
                                    <img className="article-image" src={`/images/blog/${img}`} alt="" />
                                    <span className="article-tag">{tag}</span>
                                    <h2 className="article-title">{title}</h2>
                                    <span className="article-author">{author}</span>
                                </Link>
                            ))}
                    </div>
                </div>
                <div className="blog-slider-arrows">
                    <span 
                        onClick={this.moveSlider.bind(this, -1, maxStep, currentStep)} 
                        className="blog-slider-arrow blog-slider-arrow-left" 
                        aria-label="back"
                    />
                    <div className="blog-slider-line">
                        <span 
                            className="blog-slider-line-fill" 
                            style={{width: `${100 / maxStep + (currentStep * 100 / maxStep)}%`}}
                        />
                    </div>
                    <span 
                        onClick={this.moveSlider.bind(this, 1, maxStep, currentStep)} 
                        className="blog-slider-arrow blog-slider-arrow-right" 
                        aria-label="next"
                    />
                </div>
            </div>
        );
    }//end-of-render

    private moveSlider(direction, maxStep, currentStep) {
        const nextStep = currentStep + direction;
        this.setState({
            currentStep: nextStep >= 0 && nextStep < maxStep ? nextStep : currentStep
        });
    };

    private handleResize = e => {
        this.setState(prevState => {
          return {
            windowSize: window.innerWidth
          };
        });
    };
}


// WEBPACK FOOTER //
// ./src/components/Blog/BlogSlider.tsx